import { Column, ColumnProps } from 'react-aria-components'

import { joinStyles } from '@/utils/app/theme'

import * as styles from './index.css'

type TableHeaderCellProperties = ColumnProps & {
    className?: string
}

export const TableHeaderCell = ({
    className,
    ...properties
}: Readonly<TableHeaderCellProperties>): JSX.Element => {
    return (
        <Column
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
